// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AsideLayout-module-container-B4q8W{display:grid;grid-gap:20px;gap:20px;border-radius:8px;color:#373a36}.AsideLayout-module-container-B4q8W a{color:#3567ff;color:var(--colors-accent-accent-100, #3567ff);font-weight:var(--weight-medium);text-decoration:none}.AsideLayout-module-container-B4q8W a:hover{text-decoration:underline}.AsideLayout-module-slot2-s1hQO{font-size:20px;font-weight:var(--weight-light);letter-spacing:0;line-height:33px;padding:24px}@media(min-width: 960px){.AsideLayout-module-slot2-s1hQO{font-size:26px;line-height:44px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "AsideLayout-module-container-B4q8W",
	"slot2": "AsideLayout-module-slot2-s1hQO"
};
export default ___CSS_LOADER_EXPORT___;
